import React from 'react';
import { useTranslate } from 'react-admin';
import { Typography } from '@mui/material';
import { printerDetailLabel } from './printerDetail';

interface PrinterDetailLineProps {
    health: unknown;
}

export const PrinterDetailLine: React.FC<PrinterDetailLineProps> = ({ health }) => {
    const translate = useTranslate();
    if (!health || typeof health !== 'object') return null;
    const printer = (health as Record<string, unknown>).printer;
    if (!printer || typeof printer !== 'object') return null;
    const { detail, checked_at: checkedAt } = printer as { detail?: unknown; checked_at?: unknown };
    if (typeof detail !== 'string' || detail === '') return null;
    const time = typeof checkedAt === 'string' ? new Date(checkedAt).toLocaleString() : '-';
    return (
        <Typography variant="body2" data-testid="printer-detail">
            {translate('resources.kiosk-devices.printerDetail.printedLine', { detail: printerDetailLabel(translate, detail), time })}
        </Typography>
    );
};
